<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
<!--    <div class="table-operator">-->
<!--      <a-button  @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>-->
<!--    </div>-->

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a v-if="record.confirmStatus=='00'" @click="handleEdit(record)">{{$t('button.edit')}}</a>

          <a-divider v-if="record.confirmStatus=='00'" type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{$t('button.details')}}</a>
              </a-menu-item>
              <a-menu-item v-if="record.confirmStatus =='00'" >
                <a-popconfirm :title="$t('tip.makeSureTheReviewIsApproved')" @confirm="() => handlePass(record.id)">
                  <a>{{$t('button.approval')}}</a>
                </a-popconfirm>
              </a-menu-item>
<!--               <a-menu-item v-if="record.approvalStatus =='30' && record.giftQty !=null" >-->
<!--                <a-popconfirm title="确定发货?" @confirm="() => handleDeliver(record.id)">-->
<!--                  <a>发货</a>-->
<!--                </a-popconfirm>-->
<!--              </a-menu-item>-->
              <a-menu-item v-if="record.confirmStatus =='00'">
                  <a-popconfirm :title="$t('tip.confirmRejection')" @confirm="() => handleFailure(record.id)">
                 <a>{{$t('button.rejected')}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-mkt-plan-modal ref="modalForm" @ok="modalFormOk"></efs-mkt-plan-modal>
  </a-card>
</template>

<script>

  import '@assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsMktPlanModal from './modules/EfsMktPlanModal'
  import { putAction } from '@api/manage'

  export default {
    name: 'EfsMktPlanList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EfsMktPlanModal
    },
    data () {
      return {
        description: 'efs_mkt_plan管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          // {
          //   title:'公司',
          //   align:"center",
          //   dataIndex: 'companyCode_dictText'
          // },
          // {
          //   title:'养殖场',
          //   align:"center",
          //   dataIndex: 'farmCode_dictText'
          // },
          {
            slotName: 'tableHeader.batch',
            scopedSlots: { title: 'tableHeader.batch'},
            align:"center",
            dataIndex: 'breedBatchCode'
          },
          {
            slotName: 'tableHeader.contractCode',
            scopedSlots: { title: 'tableHeader.contractCode'},
            align:"center",
            dataIndex: 'conCode'
          },
          {
            title:'存栏量',
            align:"center",
            dataIndex: 'stockAmount'
          },
          {
            title:'预估上市时间',
            align:"center",
            dataIndex: 'planMarketTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'实际上市时间',
            align:"center",
            dataIndex: 'actMarketTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'预估上市量',
            align:"center",
            dataIndex: 'planMarketQty'
          },
          {
            title:'实际出栏量',
            align:"center",
            dataIndex: 'actMarketQty'
          },
          {
            title:'预估上市重量',
            align:"center",
            dataIndex: 'planMarketWeight'
          },
          {
            title:'实际上市重量',
            align:"center",
            dataIndex: 'actMarketWeight'
          },
          // {
          //   title:'申请人',
          //   align:"center",
          //   dataIndex: 'applicant_dictText'
          // },
          {
             slotName: 'tableHeader.applicationInitiationTime',
            scopedSlots: { title: 'tableHeader.applicationInitiationTime'},
            align:"center",
            dataIndex: 'applyTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          // {
          //   title:'最后审批人',
          //   align:"center",
          //   dataIndex: 'lastApprover_dictText'
          // },
          // {
          //   title:'最后审批时间',
          //   align:"center",
          //   dataIndex: 'lastApproveTime',
          //   customRender:function (text) {
          //     return !text?"":(text.length>10?text.substr(0,10):text)
          //   }
          // },
          // {
          //   title:'申请原因',
          //   align:"center",
          //   dataIndex: 'applyReason'
          // },
          {
            title:'确认状态',
            align:"center",
            dataIndex: 'confirmStatus_dictText'
          },
          {
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
          }
        ],
        url: {
          list: "/marketPlan/efsMktPlan/list",
          delete: "/marketPlan/efsMktPlan/delete",
          deleteBatch: "/marketPlan/efsMktPlan/deleteBatch",
          exportXlsUrl: "/marketPlan/efsMktPlan/exportXls",
          importExcelUrl: "marketPlan/efsMktPlan/importExcel",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      handleFailure(id){
        putAction('/marketPlan/efsMktPlan/updateConfirmStatus', {"id": id, "confirmStatus": "40"}).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.loadData();
          } else {
            this.$message.error(res.message);
          }
        })
      },
      handlePass(id){
        putAction('/marketPlan/efsMktPlan/updateConfirmStatus', {"id": id, "confirmStatus": "30"}).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.loadData();
          } else {
            this.$message.error(res.message);
          }
        })
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>